import React, { useState, useEffect, useRef } from "react";
import {
  Atom,
  Shield,
  Search,
  Zap,
  ChevronDown,
  ChevronUp,
  ArrowRight,
} from "lucide-react";
import sutherland from "../../Images/Partners/sutherland.png";
import paytm from "../../Images/Partners/paytm.png";
import tvs from "../../Images/Partners/tvs.png";
import sis from "../../Images/Partners/sis.png";
import tata from "../../Images/Partners/tata.png";
import phonepe from "../../Images/Partners/phonepe.png";
import mahindra from "../../Images/Partners/mahindra.png";
import fincare from "../../Images/Partners/fincare.png";
import itc from "../../Images/Partners/itc.png";
import milkymist from "../../Images/Partners/milkymist.png";
import gupshup from "../../Images/Partners/gupshup.png";
import fino from "../../Images/Partners/fino.png";
import ai_logo from '../../Images/Partners/[24]7ai.png';
import LMW from '../../Images/Partners/LMW.png'
import moonlight from '../../Images/Moonlightverification.png';


const Card = ({ icon, title, description, image }) => {
  const [showContent, setShowContent] = useState(false);

  // Content mapping based on card titles
  const contentMap = {
    "Continuous Monitoring":
      "Transparent Workflows and digitized data enables us to deliver features that makes our customers & candidates happy.",
    "High Level Compliance":
      "Built-ln Compliance Engine enforcing all the needed laws based on the location.",
    "AI & ML Oriented Business Process":
      "Driven by Intelligent Technology our Automated process enables scalable solution eliminating any manual intervention.",
    "Speed And Accuracy":
      "Our Streamlined Verification Processes have a Quicker TAT and Accuracy to rely on from our Certified Quality Analysts. Criterion Provides accurate background check reports.",
  };

  return (
    <div className="relative group h-[500px] rounded-lg overflow-hidden transition-all duration-500 border border-red-600 hover:border-blue-700">
      <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center z-10 transition-all duration-500 group-hover:opacity-0 bg-[#1a0f0f]">
        <ChevronUp className="text-red-600 w-6 h-6 mb-8 animate-bounce" />
        <div className="text-white mb-4 w-16 h-16">{icon}</div>
        <h3 className="text-white text-xl font-semibold mt-4">{title}</h3>
        <ChevronDown className="text-red-600 w-6 h-6 mt-8 animate-bounce" />
      </div>
      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
        <div
          className="absolute inset-0 bg-cover bg-center transform -translate-y-full group-hover:translate-y-0 group-hover:animate-bounce-once transition-transform duration-1000 ease-out"
          style={{
            backgroundImage: image ? `url(${image})` : "none",
          }}
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 h-full flex flex-col items-center justify-center p-6 text-center">
          <h3 className="text-white text-2xl font-bold mb-4">{title}</h3>
          {description && <p className="text-gray-200 mb-6">{description}</p>}

          {/* Show content when clicked */}
          {showContent ? (
            <div className="text-gray-200 mb-6 text-center">
              <p className="font-bold uppercase">{title}</p>
              <p>{contentMap[title]}</p>
            </div>
          ) : (
            <div className="group/button inline-flex flex-col items-center">
              <button
                className="text-white flex items-center gap-2 font-medium"
                onClick={() => setShowContent(true)}
              >
                Explore{" "}
                <ArrowRight className="w-4 h-4 transform group-hover/button:translate-x-1 transition-transform" />
              </button>
              <div className="h-0.5 w-full bg-blue-700 mt-1" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

function Layer2() {
  const cards = [
    {
      icon: <Zap className="w-full h-full" />,
      title: "Speed And Accuracy",
      description: "40 Mn+ employees verified",
      image:
        "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2832&q=80",
    },
    {
      icon: <Atom className="w-full h-full" />,
      title: "AI & ML Oriented Business Process",
      description:
        "Advanced artificial intelligence and machine learning solutions",
      image:
        "https://images.unsplash.com/photo-1677442136019-21780ecad995?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2832&q=80",
    },
    {
      icon: <Shield className="w-full h-full" />,
      title: "High Level Compliance",
      description: "Meeting the highest security and regulatory standards",
      image:
        "https://images.unsplash.com/photo-1639762681057-408e52192e55?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2832&q=80",
    },
    {
      icon: <Search className="w-full h-full" />,
      title: "Continuous Monitoring",
      description: "24/7 real-time monitoring and alerts",
      image:
        "https://plus.unsplash.com/premium_photo-1682464699619-1cb44ff3175e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8Y29udGludW91cyUyMG1vbml0b3Jpbmd8ZW58MHwxfDB8fHww",
    },
  ];

  const images = [
    {
      src: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      title: "Educational Verification",
      description:
        "Ensure the authenticity of academic credentials, degrees, and institutions for reliable hiring decisions.",
      buttonText: "Verify Credentials",
      route: "/education-verification",
    },
    {
      src: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      title: "Employment Verification",
      description:
        "Validate past job roles, work experience, and professional history with confidence.",
      buttonText: "Confirm Employment",
      route: "/employment-verification",
    },
    {
      src: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      title: "Address Verification",
      description:
        "Confirm residential details for secure documentation and accurate records.",
      buttonText: "Verify Address",
      route: "/address-verification",
    },
    {
      src: "https://images.unsplash.com/photo-1589578527966-fdac0f44566c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      title: "Criminal Background Check",
      description:
        "Run detailed background screenings across multiple jurisdictions to ensure safety and compliance.",
      buttonText: "Check Records",
      route: "/criminal-background-check",
    },
    {
      src: "https://www.shutterstock.com/image-photo/human-hand-holding-digital-identification-600nw-2166069807.jpg",
      title: "Identity Verification",
      description:
        "Leverage advanced authentication to prevent fraud and verify identities securely.",
      buttonText: "Authenticate Now",
      route: "/id-verification",
    },
    {
      src: "https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      title: "Reference Verification",
      description:
        "Cross-check professional and personal references for a trustworthy assessment.",
      buttonText: "Validate References",
      route: "/reference-check-verification",
    },
    {
      src: "https://www.keenesystems.com/hubfs/blog-images/database-application.jpg",
      title: "Database Screening",
      description:
        "Scan global databases to detect discrepancies and verify critical details.",
      buttonText: "Run Search",
      route: "/global-database-check",
    },
    {
      src: "https://images.pexels.com/photos/16345434/pexels-photo-16345434/free-photo-of-icons-on-smartphone-touchscreen.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
      title: "Social Media Verification",
      description:
        "Assess online presence and social activity for a deeper understanding of digital behavior.",
      buttonText: "Analyze Profile",
      route: "/social-media-verification",
    },
    {
      src: moonlight,
      title: "Moonlighting Verification",
      description:
        "Moonlighting-when employees work for multiple organizations simulataneously-can lead to conflicts of interest, reduced productivity, and data security risks.",
      buttonText: "Analyze Profile",
      route: "/moonlighting-verification",
    },
    {
      src: "https://images.unsplash.com/photo-1579154204601-01588f351e67?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      title: "Drug Testing",
      description:
        "Ensure a drug-free workplace with professional, confidential substance screenings.",
      buttonText: "Schedule Test",
      route: "/drug-test-verification",
    },
    {
      src: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
      title: "Credit Check",
      description:
        "Evaluate financial credibility with a comprehensive credit history assessment.",
      buttonText: "Check Score",
      route: "/credit-cibil-check",
    },
  ];

  // Array of partner logos
  const partnerLogos = [
    sutherland,
    paytm,
    tvs,
    sis,
    tata,
    phonepe,
    mahindra,
    fincare,
    itc,
    milkymist,
    gupshup,
    fino,
    ai_logo,
    LMW,
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const sliderRef = useRef(null);

  const extendedImages = [...images, images[0]];

  useEffect(() => {
    const slideInterval = setTimeout(() => {
      if (currentIndex === images.length) {
        setIsTransitioning(false);
        setCurrentIndex(0);
      } else {
        setIsTransitioning(true);
        setCurrentIndex((prevIndex) => prevIndex + 1);
      }
    }, 15000); // Adjusted to 15 seconds

    return () => clearTimeout(slideInterval);
  }, [currentIndex, images.length]);

  const [selectedService, setSelectedService] = useState("education-verification");

  const handleServiceChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedService(selectedValue);
    setCurrentIndex(
      images.findIndex((image) =>
        image.title.toLowerCase().includes(selectedValue.split("-").join(" "))
      ) || 0
    );
  };

  return (
    <div>
      <div className="min-h-screen bg-black py-12 px-4 sm:px-6 lg:px-8 select-none">
        <div className="max-w-7xl mx-auto">
          {/* layer 1 */}
          <div className="text-center mb-16">
            <div className="flex flex-col md:flex-row items-start gap-8 md:gap-28">
              <h2 className="text-2xl text-white mb-4 text-left">
                Why Choose{" "}
                <span className="text-[#eb3434] text-5xl block font-bold">
                  Criterion Screeners
                </span>
              </h2>
              <p className="text-[#989a9a] max-w-2xl md:mt-0 md:ml-10 text-justify">
              Criterion Screeners serves a vital role for organizations seeking to minimize risk and ensure compliance through comprehensive background verification. Our services encompass a wide range of checks, including employment, education, criminal, and identity verification, enabling companies to make informed hiring decisions. By providing thorough and accurate screenings, Criterion Screeners helps mitigate the potential for hiring individuals with problematic backgrounds, thereby safeguarding a company's reputation, assets, and employees. Furthermore, We assist businesses in adhering to industry-specific regulations and compliance requirements, particularly crucial in sectors like finance and healthcare. Utilizing automated platforms and technology, We aim to streamline the verification process, delivering efficient and accurate results with real-time data and reports. Ultimately, Criterion Screeners offers businesses a means to enhance security, ensure regulatory compliance, improve hiring practices, and increase operational efficiency.
              </p>
            </div>
          </div>

          {/* <div className="flex flex-row gap-4 items-center justify-center pb-6 underline">
            <h2 className="text-white underline decoration-red-500 underline-offset-8">
              Read More
            </h2>
            <h3>
              <MoveRight className="w-6 h-6 text-red-500 mt-1 " />
            </h3>
          </div> */}

          {/* layer 2 */}
          <div className="flex flex-col items-center justify-center pt-10 pb-10">
            <h1 className="text-white mb-4 text-left text-2xl font-thin text-[30px]">
              Digital and Intelligent{" "}
              <span className="text-[#b7372e] font-bold">
                Background Screening
              </span>
            </h1>
            <p className="text-[#989a9a] text-center max-w-[850px] mx-auto px-4 sm:px-6 lg:px-8 ">
              Transparent workflows and digitized data enable Criterion
              screeners to deliver features that make our customers happy with
              accurate Employee Background Verification
            </p>
          </div>

          <div className="min-h-fit bg-black p-8 ">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {cards.map((card, index) => (
                  <Card key={index} {...card} />
                ))}
              </div>
            </div>
          </div>

          {/* Updated Partner Logos Section */}
          <div className="flex flex-col items-center justify-center text-center mb-20 mt-20">
            <h1 className="text-white mb-4 font-thin text-[24px]">
              We work with some of the Best -{" "}
              <span className="text-[#b7372e] font-bold">
                Leaders in the Industry
              </span>
            </h1>
            <div className="w-full overflow-hidden mt-20">
              <div className="flex animate-marquee whitespace-nowrap">
                {/* Render the partnerLogos array twice to create a seamless loop */}
                {[...partnerLogos, ...partnerLogos, ...partnerLogos].map((logo, index) =>
                  logo ? (
                    <img
                      key={index}
                      src={logo}
                      alt={`Partner ${index + 1}`}
                      className="h-20 w-52 mx-4"
                    />
                  ) : null
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Layer 3  */}
      <div className="relative w-full mx-auto bg-black overflow-hidden">
        <div className="relative w-full flex justify-center items-center px-8 flex-col sm:flex-row">
          <h1 className="text-4xl sm:text-5xl  text-[#b7372e] tracking-tight mb-2 sm:mb-0">
            {/* Our Services */}
            <span className="text-white font-thin text-[24px"> Our </span>
            <span className="font-bold text-[#b7372e]"> Services</span>
          </h1>

          {/* Dropdown positioned to the right on desktop and below the heading on mobile */}
          <div className="w-full sm:w-80 flex justify-center sm:absolute sm:right-8 sm:top-1/2 sm:transform sm:-translate-y-1/2">
            <select
              id="service-select"
              value={selectedService}
              onChange={handleServiceChange}
              className="w-3/4 sm:w-full p-2 text-sm sm:text-lg font-medium text-gray-800 bg-white border border-gray-200 rounded-xl shadow-md appearance-none focus:outline-none focus:ring-2 focus:ring-[#b7372e] focus:border-[#b7372e] hover:border-gray-400 transition-all duration-300 ease-in-out text-center"
            >
              <option value="educational-verification">
                Educational Verification
              </option>
              <option value="employment-verification">
                Employment Verification
              </option>
              <option value="address-verification">Address Verification</option>
              <option value="criminal-background-check">
                Criminal Background Check
              </option>
              <option value="identity-verification">
                Identity Verification
              </option>
              <option value="reference-verification">
                Reference Verification
              </option>
              <option value="database-screening">Database Screening</option>
              <option value="social-media-verification">
                Social Media Verification
              </option>
              <option value="moonlighting-verification">Moonlighting Verification</option>
              <option value="drug-testing">Drug Testing</option>
              <option value="credit-check">Credit Check</option>
            </select>

            <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
              {/* <svg
                className="w-6 h-6 text-gray-600"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 12a1 1 0 01-.7-.3l-3-3a1 1 0 111.4-1.4L10 9.6l2.3-2.3a1 1 0 011.4 1.4l-3 3a1 1 0 01-.7.3z"
                  clipRule="evenodd"
                />
              </svg> */}
            </div>
          </div>
        </div>

        <div id="slides-container" className="mt-4">
          <div className="relative w-max-w-[1450px] mx-auto overflow-hidden rounded-lg mt-5 mb-5">
            <div className="w-full h-full">
              <div
                ref={sliderRef}
                className="flex transition-transform duration-2000 ease-in-out"
                style={{
                  transform: `translateX(-${currentIndex * 100}%)`,
                  transition: isTransitioning
                    ? "transform 2.0s ease-in-out"
                    : "none",
                }}
              >
                {extendedImages.map((image, index) => {
                  const isLayer3 = index >= images.length; // Check if it's Layer 3 content
                  return (
                    <div
                      key={index}
                      className={`w-full h-[500px] md:h-[600px] lg:h-[700px] flex-shrink-0 relative ${
                        isLayer3 ? "layer3-content" : ""
                      }`}
                    >
                      <img
                        src={image.src}
                        alt={`Slide ${index + 1}`}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute bottom-10 left-10 w-[80%] md:w-[500px] p-6 bg-white bg-opacity-80 rounded-tl-lg rounded-tr-lg">
                        <h2 className="text-lg md:text-2xl font-semibold mb-4">
                          {image.title}
                        </h2>
                        <p className="text-blue-700 text-sm md:text-base mb-6">
                          {image.description}
                        </p>
                        <a
                          // href="/"
                          href={image.route}
                          className="inline-block px-4 py-2 md:px-6 md:py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700"
                        >
                          {image.buttonText}
                        </a>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <button
              className="absolute top-1/2 left-2 transform -translate-y-1/2 p-4 text-white bg-black bg-opacity-50 hover:bg-opacity-70 rounded-full"
              onClick={() =>
                setCurrentIndex((prevIndex) =>
                  prevIndex === 0 ? images.length - 1 : prevIndex - 1
                )
              }
            >
              ❮
            </button>
            <button
              className="absolute top-1/2 right-2 transform -translate-y-1/2 p-4 text-white bg-black bg-opacity-50 hover:bg-opacity-70 rounded-full"
              onClick={() =>
                setCurrentIndex(
                  (prevIndex) => (prevIndex + 1) % (images.length + 1)
                )
              }
            >
              ❯ 
            </button>
          </div>
        </div>
      </div>

      {/* Tailwind CSS for Marquee Effect */}
      <style jsx>
        {`
          @keyframes marquee {
            0% {
              transform: translateX(0%); /* Start at the beginning */
            }
            100% {
              transform: translateX(-100%); /* Translate by the width of the first set of logos */
            }
          }

          /* Apply the animation to the flex container */
          .animate-marquee {
            display: flex; /* Ensure it's a flex container */
            animation: marquee 80s linear infinite; /* Increased duration for smoothness */
            width: fit-content; /* Ensure the container fits its content */
          }

          .animate-marquee:hover {
            animation-play-state: paused;
          }

          /* Ensure individual logo containers don't shrink */
          .animate-marquee > * {
            flex-shrink: 0;
          }
        `}
      </style>
    </div>
  );
}

export default Layer2;
